import { FC } from 'react';
import CommonHeader from '../CommonHeader';

interface IPaymentHeaderProps{}

const PaymentHeader: FC<IPaymentHeaderProps> = ()=>{
  return <CommonHeader/>;
}

export default PaymentHeader;